module.exports = __webpack_public_path__ + "assets/c80e32a7570be9b2043b1e33a31b0f65.mp3";